var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgX(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#3CEAC1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5133 25.2979C28.1622 25.8984 28.1622 26.9492 27.5133 27.5496C27.2137 27.8499 26.8144 28 26.415 28C25.9657 28 25.5663 27.8499 25.2668 27.5496L20.025 22.2955L14.7332 27.5496C14.4337 27.8499 14.0343 28 13.6349 28C13.1856 28 12.7863 27.8499 12.4867 27.5496C11.8378 26.9492 11.8378 25.8984 12.4867 25.2979L17.7285 19.9937L12.4867 14.7396C11.8378 14.1392 11.8378 13.0884 12.4867 12.4879C13.0858 11.8374 14.1342 11.8374 14.7332 12.4879L20.025 17.742L25.2668 12.4879C25.8658 11.8374 26.9142 11.8374 27.5133 12.4879C28.1622 13.0884 28.1622 14.1392 27.5133 14.7396L22.2715 20.0438L27.5133 25.2979Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.ec5a846e73552eb56d08cc393885de2e.svg";
export { ForwardRef as ReactComponent };